import Vue from 'vue'
import Vuetify from 'vuetify'
import VueTelInput from 'vue-tel-input';
import JsonExcel from "vue-json-excel";

import router from './router';
import store from './store';
import App from './App.vue'
import printJS from 'print-js';
import VueQrcodeReader from 'vue-qrcode-reader';
//import VueAnalytics from 'vue-analytics'
import 'vue-tel-input/dist/vue-tel-input.css';
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'typeface-roboto';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/js/all.min.js';
import '@mdi/font/css/materialdesignicons.css';
// import './registerServiceWorker';
// import CKEditor from '@ckeditor/ckeditor5-vue';
import money from 'v-money';
import 'vuetify/dist/vuetify.min.css';
import './assets/css/ck-content.css';
import VueSocialSharing from 'vue-social-sharing'
import Toasted from 'vue-toasted';
const optionsTelInput = {
  preferredCountries: ["ID"],
  validCharactersOnly: true,
  defaultCountry: "ID",
  autoFormat: true,
  maxlength: 15,
  placeholder: "Phone Number",
  showDialCode: true,
  invalidMsg: "Invalid Phone Number Format",
  mode: 'international',
  dropdownOptions: {
    showDialCodeInList: true,
    showDialCodeInSelection: true,
    showFlags: true,
    showSearchBox: false,
  }
  
}
// Vue.use(CKEditor);
Vue.use(money, { precision: 4 });
Vue.use(VueTelInput, optionsTelInput);
Vue.use(VueQrcodeReader)
Vue.use(VueSocialSharing)

Vue.component("downloadExcel", JsonExcel);

// set true if deploy to production
// const isProd = (process.env.NODE_ENV === 'production');
// Vue.use(VueAnalytics, {
//   id: 'UA-115628282-6',
//   router,
//   debug: {
//     enabled: false,
//     sendHitTask: isProd
//   }
// })

Vue.config.productionTip = false

Vue.use(Vuetify);

Vue.use(Toasted, {
  duration: 5000,
  position: 'top-center',
  iconPack: 'material'
})

var filter = function(text, length, clamp){
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);

new Vue({
  vuetify: new Vuetify({
    icons: {
      iconfont: 'mdiSvg',
    },
    theme: {
      primary: "#D42A2A",
      secondary: "#D42A2A",
      accent: "#673ab7",
      error: "#FF5252",
      warning: "#FB8C00",
      info: "#1976D2",
      success: "#4CAF50"
    }
  }),
  router,
  store,
  printJS,
  VueQrcodeReader,
  render: h => h(App)
}).$mount('#app')
